const PREFIX = 'OPEN_PLATFORM_LOGIN_';

export const OPEN_PLATFORM_LOGIN_SET_APP = `${PREFIX}SET_APP`;

export const OPEN_PLATFORM_LOGIN_REPLACE_VIEW = `${PREFIX}REPLACE_VIEW`;

export const OPEN_PLATFORM_LOGIN_SET_IS_MOKA_OPEN_API_REDIRECT = `${PREFIX}SET_IS_MOKA_OPEN_API_REDIRECT`;
